export enum PrivacyType {
    TrattDatiPersonali = 'DatiPersonali',
    InizPromozionaliEgl = 'PromoEgl',
    InizPromoTerzeP = 'PromoTerzi',
    AnalisiMercato = 'AnalisiMercato',
}
